import type { LinkDetailData } from '../components/LinkDetail';

export const designReviewLink: LinkDetailData = {
  id: "design-review-link",
  url: "https://www.instagram.com/reel/design-review/",
  domain: "instagram.com",
  title: "The GREATEST DnB Tune of All Time!? #drumandbass #dnb #liquiddnb",
  status: "done",
  sync_target_page_id: "Test destination",
  sync_target_adapter: "outline",
  sync_target_url: "https://outline.example.com/test-destination",
  results: [
    {
      processor_name: "song",
      display_name: "Song Extractor",
      summary:
        "The content is a discussion about the greatest drum and bass tunes of all time, explicitly naming several tracks and artists.",
      data: {
        songs: [
          {
            title: "Touch",
            artist: "Hybrid Minds",
            spotifyUrl: "https://open.spotify.com/track/2QZw9tAtxNwY1FzwjMd5ic",
          },
          {
            title: "Right Here, Right Now (Friction One in the Jungle Remix)",
            artist: "Friction",
            spotifyUrl: "https://open.spotify.com/track/7DWXlF4vK5Fv5CXwQK4L8N",
          },
          {
            title: "Independent",
            artist: "Halogenix",
            spotifyUrl: "https://open.spotify.com/track/3zSx6vI7uWgYdM8fR0kWGu",
          },
          {
            title: "Sun King",
            artist: "State of Mind",
            resolved: false,
          },
          {
            title: "Hold Your Colour (Remix)",
            artist: "Pendulum",
            album: "Hold Your Colour",
            spotifyUrl: "https://open.spotify.com/track/1uq6q4h0Q1LqsJ2c9fW7Q9",
          },
          {
            title: "A Very Long Drum and Bass Song Title That Should Wrap Cleanly In The Review Layout",
            artist: "Afterglow Collective Featuring A Surprisingly Long Artist Credit",
            resolved: false,
          },
        ],
      },
    },
    {
      processor_name: "article",
      display_name: "Content Summarizer",
      summary:
        "A group of drum and bass fans debate which track deserves the title of the greatest DnB tune ever. Suggestions include Hybrid Minds' 'Touch,' Friction's 'Right Here, Right Now,' Halogenix's 'Independent,' State of Mind's 'Sun King,' Andy C's 'Heart Beats Loud,' Pendulum's 'Hold Your Colour' remix and album, and Wilkinson's 'Afterglow.'",
      data: {
        title: "Drum and Bass Fans Debate the Greatest Tune of All Time",
        summary:
          "A group of drum and bass fans debate which track deserves the title of the greatest DnB tune ever, highlighting both technical impact and emotional significance.",
        key_points: [
          "Multiple iconic drum and bass tracks are named as contenders for the greatest tune of all time.",
          "Fans emphasize both technical impact and emotional significance, especially for festival energy and personal memories.",
        ],
        topics: ["drum and bass", "music debate"],
      },
    },
  ],
};
